import { Component, Input, OnInit, ViewContainerRef } from '@angular/core';
import { Observable, Subscription } from 'rxjs';
import { ModalService } from './modal.service';
import { BusinessNavKeybindService } from '../../keybind.service';
import { filter } from 'rxjs/operators';
import { ESCAPE } from '@angular/cdk/keycodes';

@Component({
  selector: 'atlas-modal',
  templateUrl: './modal.component.html',
  styleUrls: ['./modal.component.scss']
})
export class ModalComponent implements OnInit {
  @Input() titleText: string;
  @Input() height: number | string;
  showing: boolean = false;
  closing: boolean = false;
  mobile$: Observable<boolean>;
  closeSubscription: Subscription;

  constructor(private viewContainerRef: ViewContainerRef, private modalService: ModalService, private keybindService: BusinessNavKeybindService) {
    setTimeout(() => this.showing = true, 0);
    this.closeSubscription = this.keybindService.keyEvent$
      .pipe(
        filter((event: KeyboardEvent) => event.keyCode === ESCAPE),
      ).subscribe(() => {
        this.closeModal();
      });
  }

  ngOnInit(): void {
    this.mobile$ = this.modalService.mobile$;
  }

  get heightStyle(): string {
    if (this.height === null || typeof this.height === 'undefined') {
      return 'auto';
    }
    if (typeof this.height === 'number') {
      return this.height + 'px';
    }
    return this.height;
  }

  closeModal(): void {
    if (this.closing) {
      return;
    }
    this.showing = false;
    this.closing = true;
    if (!!this.closeSubscription) {
      this.closeSubscription.unsubscribe();
    }
    this.modalService.close();
    // Set active subscription to null, this will unsubscribe() the last one as well
    this.keybindService.setOrUpdateListItemActiveSubscription(null);
  }
}
